
// #region imports

// #region vue
import { Component, Prop, Vue } from 'vue-property-decorator'
// #endregion

// #region interfaces
import { BookingInterface } from '@/types/interfaces/booking'
// #endregion

// #endregion

@Component
export default class BookingClientPhoneNumber extends Vue {
  @Prop({ required: true }) readonly item!: BookingInterface
}
